<template>
  <div class="c-select-search" @click.stop>
    <div class="c-select-search__input">
      <Input v-model="temp.value" size="xs" trim @input="input" />
      <Icon2 size="15" variant="search" />
    </div>
    <div v-if="$slots.default" class="c-select-search__nodata">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Icon2 from '@/components/Icon2';
import Input from '@/components/Input';
export default {
  props: {
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: [Number, String],
      required: false
    }
  },
  components: {
    Icon2,
    Input
  },
  data() {
    return {
      temp: {
        value: this.value
      }
    };
  },
  methods: {
    input() {
      this.$emit('input', this.temp.value);
    }
  }
};
</script>
